export default {
  common: {
    addToCart: 'Add to cart',
    removeFromCart: 'Remove from cart',
    next: 'Next',
    details: 'Details',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    sender: 'Sender',
    recipient: 'Recipient',
    address: 'Address',
    pickupAddressTitle: 'Pickup address',
    collectionDateTitle: 'Collection date',
    billingInformationTitle: 'Billing information',
    additionalInfo: 'Additional Info',
    arrivesAt: 'Arrives at',
    postalCode: 'Postal Code',
    streetAddress: 'Street Address',
    city: 'City',
    save: 'Save',
  },
  cartPages: {
    shoppingCart: 'Shopping cart',
    selectUserType: 'Select user type',
    orderDetails: 'Order details',
    orderDetailsBilling: 'Order Details',
    proceedToCheckout: 'Proceed to checkout',
    emptyCart: 'Your cart is empty',
    errorCart: 'Error loading cart',
    shippingFee: 'Shipping fee',
    totalAmount: 'Total amount (Includes VAT)',
    senderDetails: 'Sender details',
    receiverDetails: 'Receiver details',
  },
  validation: {
    firstNameRequired: 'First Name is required',
    lastNameRequired: 'Last Name is required',
    invalidEmail: 'Invalid email',
    emailRequired: 'Email is required',
    phoneNumberRequired: 'Phone number is required',
    userTypeRequired: 'User type is required',
    invalidUserType: 'Invalid user type',
  },
  products: {
    searchPlaceholder: 'Search products',
    filterProducts: 'Filter products',
    loadMore: 'Load more',
    noProductsFound: 'No products found.',
    tryDifferentFilters: 'Try different filters or search terms.',
    errorLoadingProducts: 'Error loading products',
  },
  footer: {
    aboutUs: 'About us',
    tos: 'Terms of service',
    privacyPolicy: 'Privacy policy',
  },
  delivery: {
    leaveAtDoor: 'Leave it at door',
    trackDelivery: 'Track your delivery',
    messageDriver: 'A message to the driver',
    deliveryInfo: 'Delivery information',
    additionalServices: 'Additional services',
  },
  homeHeader: {
    title: 'Home Recycling Services',
    text1: 'You only pay a €4.90 transportation fee and an item-specific fee.',
    text2:
      'Order the pickup of items that need recycling, washing, or maintenance right from your doorstep!',
    text3: 'Enjoy life with a clear conscience!',
    linkText: 'How does it work?',
    deliveryText: 'Deliveries',
    recycledItemsText: 'Recycled items',
    savedCO2Text: 'Saved CO2 g',
    subtitlePart1: 'Send',
    subtitlePart2: ' easily from your doorstep!',
  },
  homeFooter: {
    title: 'How does it work?',
    text1:
      'From the MyFetch store, you can easily and quickly order pick-ups to your doorstep for various home services. The store offers services for recycling, laundry transportation to laundromats, and reuse of old devices. Services are continuously added, and currently, there are participants related to the circular economy, such as UFF and Inrego.',
    text2:
      "You can combine laundry and old IT device recycling into one pick-up and simultaneously send cardboard and bottles for recycling – convenient, isn't it!",
    text3:
      'When you order a pick-up Mon – Fri by 2 pm, the pick-up will be carried out the same evening. From the calendar, you can also choose a suitable pick-up day for yourself. All pickups occur between 5 pm – 10 pm, and we will notify the exact pick-up time with an accuracy of one hour in advance on the pick-up day.',
    text4:
      'The prices for different services, such as laundry services or bicycle maintenance, are charged separately by the service provider, see product details. Enexus provides the service provider with the personal data required for billing and return transport during the order.',
  },
  userTypePicker: {
    startTransporting: "Let's start transporting",
    selectZip: 'Start by selecting your zip code',
    sender: 'I am the sender',
    receiver: 'I am the receiver',
    receiverInfo:
      "If you are the recipient, ensure the sender is present at the collection time. We won't repeat the pickup if the sender is absent or if there are uncontrollable issues.",
    collectionZipPlaceholder: 'Enter collection zip code',
    deliveryZipPlaceholder: 'Enter delivery zip code',
  },
}
